<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Partner data</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <span>Modtaget dato: {{ this.receivedDate | date : 'dd.MM.yyyy kl. HH:mm' }}</span>
</div>

<div mat-dialog-content>
  <pre [innerHTML]="this.payload | jsonString : [true, 2]"></pre>
</div>

<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Luk</button>
</div>
